// @codekit-prepend quiet "../node_modules/jquery/dist/jquery.js";
// @codekit-prepend quiet "../node_modules/foundation-sites/dist/js/foundation.min.js";
// @codekit-prepend quiet "../node_modules/what-input/dist/what-input.js";
// @codekit-prepend quiet "../../../assets/colorbox/js/colorbox.min.js";


"use strict";$(document).foundation();
//# sourceMappingURL=app.js.map


jQuery(document).ready(function( $ ) {

    // Hamburger Menu
    $('button.hamburger').on('click', function () {
        $($(this)).toggleClass('is-active');
        $('#top').toggleClass('overlay-is-active');
    });
    $('#overlay').on('click', function () {
        $('button.hamburger').removeClass('is-active');
        $('#top').toggleClass('overlay-is-active');
        //$('#mobile-menu').foundation('toggle');

    });
    $(document).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll > 150) $('.scroll-top-wrapper').addClass('show');
        else
        $('.scroll-top-wrapper').removeClass('show');
    });

});
jQuery(function($){$('a[data-lightbox]').map(function(){$(this).colorbox({loop:!1,rel:$(this).attr('data-lightbox'),maxWidth:'95%',maxHeight:'95%'})})});
